module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Actions":"Actions","exportLabel":"Export {reportType} (DOCX)","addReferencePeriod":"Add reference period"},"de":{"Actions":"Aktionen","exportLabel":"{reportType} Bericht als DOCX exportieren","addReferencePeriod":"Referenzperiode hinzufügen"}}')
  delete Component.options._Ctor
}
